const get_started = {
    page_title: 'البدء',
    title: 'شيء لمساعدتك على النجاح',
    subtitle: 'بعض الأشياء التي يمكنك القيام بها للحصول بسرعة على قيمة Logto',
    develop: {
        title: 'التطوير: قم بدمج تطبيقك في 5 دقائق',
        title_cloud: 'التطوير: قم بدمج تطبيقك بأمان في دقائق',
        subtitle_cloud: 'أو قم بدمج تطبيقك في 5 دقائق باستخدام SDKs والبرامج التعليمية الجاهزة لدينا.',
        try_mcp: 'جرب التكامل بأمر واحد مع MCP',
    },
    customize: {
        title: 'تخصيص: قدم تجربة تسجيل دخول رائعة',
        preview: {
            title: 'تحقق من المعاينة المباشرة لتجربة تسجيل الدخول التي قمت بتخصيصها للتو',
            subtitle: 'جرب تجربة تسجيل الدخول الخاصة بـ Logto الآن لمعرفة كيف يعمل',
        },
        connector: {
            title: 'إضافة المزيد من الموصلات لدعم طرق تسجيل الدخول الاجتماعي الأخرى',
            subtitle: 'جرب تسجيل الدخول بدون كلمة مرور وقم بتمكين تجربة آمنة وسلسة لعملائك',
        },
        continue_customizing: 'متابعة التخصيص',
        try_now: 'جرب الآن',
        add_more: 'إضافة المزيد',
    },
    secure: {
        title: 'تأمين: حماية مواردك',
    },
    manage: {
        title: 'إدارة: تعريف التحكم في الوصول لمنتجك والمستخدمين',
        rbac: {
            title: 'إضافة التحكم في الوصول بناءً على الأدوار لحماية مواردك',
            subtitle: 'تحكم في مواردك من خلال تفويض الأدوار المقياسي لحالات الاستخدام المتنوعة.',
        },
        create_roles: 'إنشاء الأدوار',
    },
    convert_to_production: {
        card_title: 'جاهز للبث المباشر؟ لا تنس إطلاق إعداد الإنتاج الخاص بك!',
        title: 'لا تُبقِ مشروعك عالقًا في وضع التطوير',
        subtitle: 'أنت تستخدم مستأجرًا للتطوير للاختبار المجاني. لبث المشروع، أنشئ أو حوّل لمستأجر الإنتاج. هل تحتاج إلى شيء مخصص؟ <a>اتصل بنا</a>',
        convert_button: 'تحويل إلى مستأجر الإنتاج',
    },
    oss_cloud: {
        try: {
            title: 'تجاوز أعباء التشغيل وجرب Logto Cloud مجانًا',
            badge: 'موصى به',
            description: 'احصل على Logto مُدار بالكامل من دون أي صيانة، بالإضافة إلى تكامل سريع عبر MCP، ودعم تعدد المستأجرين، وتعاون الفريق، وجميع الميزات المدفوعة مشمولة. ابدأ مجانًا من دون بطاقة ائتمان.',
            action: 'استكشف Logto Cloud',
        },
        private_cloud: {
            title: 'هل تحتاج إلى الامتثال أو نشر مخصص؟',
            card_title: 'سحابة خاصة',
            description: 'احصل على مثيل Logto مخصص مع عزل كامل للبيانات، ونطاق مخصص، وضمانات SLA. مثالي للمؤسسات ذات متطلبات الإقامة الجغرافية للبيانات أو الامتثال الصارمة. نحن نتولى البنية التحتية لتتمكن من التركيز على منتجك.',
        },
        sidebar: {
            title: 'ركّز على البناء، لا على الاستضافة.',
            description: 'دع Logto Cloud يتولى البنية التحتية للمصادقة نيابةً عنك.',
            action: 'جرّب Logto Cloud',
        },
    },
    view_all: 'عرض الكل →',
};
export default Object.freeze(get_started);
